// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__QUKeW","footer":"Footer_footer__vwF1Q","left":"Footer_left__5hYPc","right":"Footer_right__1U3Zv","logo":"Footer_logo__m8dHt"};